import { Box, Flex, Stack, useToast } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { useCopyToClipboard } from 'react-use';
import { RxClipboardCopy } from 'react-icons/rx';
import { H2 } from '@/components/Headings';
import { colors } from '@/styles/theme/colors';
import { TextDefault } from '@/components/Texts';

const colorValues = [
  '#0a4b72',
  '#0072B1',
  '#64C8FF',
  '#303030',
  '#646464',
  '#F8F8F8',
];

const Colors = () => {
  const { t } = useTranslation('main');
  const toast = useToast();
  const [, copy] = useCopyToClipboard();

  const handleCopyColor = (index: number) => {
    copy(colorValues[index]);
    toast({
      description: t('assets.colors.copied', {
        color: t(`assets.colors.items.${index}`),
      }),
      status: 'success',
      duration: 1000,
      isClosable: true,
    });
  };

  return (
    <Stack color={colors.diment.darkBlue} align={'center'} spacing={8}>
      <H2>{t('assets.colors.heading')}</H2>

      <Flex wrap={'wrap'} gap={8} justify={'center'}>
        {Array(6)
          .fill(null)
          .map((_, index) => (
            <Stack
              align={'center'}
              key={index}
              cursor={'pointer'}
              onClick={() => handleCopyColor(index)}
            >
              <Box
                border={index === 4 ? '1px solid gray' : ''}
                w={{ base: 20, md: 28, lg: 32 }}
                h={{ base: 20, md: 28, lg: 32 }}
                rounded={'full'}
                bgColor={colorValues[index]}
              />
              <Flex align={'center'} gap={2}>
                <TextDefault fontWeight={'medium'}>
                  {t(`assets.colors.items.${index}`)}
                </TextDefault>
                <RxClipboardCopy />
              </Flex>
              <TextDefault fontWeight={'medium'}>
                {colorValues[index]}
              </TextDefault>
            </Stack>
          ))}
      </Flex>
    </Stack>
  );
};

export default Colors;
